export const DASHBOARD_PROPS = {
  PAGE: {
    TITLE: 'Dashboard',
    LIVE_BADGE: 'Live',
    DATE_LABEL_DEFAULT: 'Last 7 days',
  },
  STAT_CARDS: {
    SMART_COOLER_PRODUCTS: 'Smart Cooler Products',
    VDI_TRANSACTIONS: 'VDI Transactions',
    OPERATORS: 'Operators',
    PROVIDERS: 'Providers',
  },
  CHARTS: {
    DEFAULT_SUBTITLE: 'Total · Accepted · Processed',
    ALERTS_TITLE: 'Alerts',
    ALERTS_SUBTITLE: 'Alert count over time',
  },
  RECENT_ALERTS: {
    TITLE: 'Recent Alerts',
    SUBTITLE_PREFIX: 'Latest',
    SUBTITLE_SUFFIX: 'alerts',
    EMPTY: 'No recent alerts',
    VIEW_ALL: 'View all',
    STATUS_OPEN: 'OPEN',
  },
};
